
class BaseOrderService {
    constructor(order, settings, categoryService, branch){
        this.className = "BaseOrderService";
        this.order = order;
        this.settings = settings;
        this.categoryService = categoryService
        this.branch = branch
    }

    setOrder(order) {
        if (!order || order.className != "Order") {
            throw new Error("Order must be an instance of Order");
        }
        this.order = order;
    }

    setSettings(settings) {
        if(!settings || settings.className != "OrderSettings") {
            throw new Error("orderSettings must be an instance of OrderSettings");
        }
        this.settings = settings
    }

    setCategoryService(categoryService) {
        if(!categoryService || categoryService.className!= "CategoryService") {
            throw new Error("categoryService must be an instance of CategoryService");
        }
        this.categoryService = categoryService
    }

    setBranch(branch) {
        if(!branch || branch.className!= "Branch") {
            throw new Error("branch must be an instance of Branch");
        }
        this.branch = branch
    }
}

export default BaseOrderService;
